<template>
  <component :is="componentToUse" :key="reportRoute" :config="getExternalBIReport.config" />
</template>

<script>
import { useStore as mainUseStore } from '@/store'
import LookerBIReport from '@/modules/external-bi/views/components/LookerBIReport.vue'
import PowerBIReport from '@/modules/external-bi/views/components/PowerBIReport.vue'
import UnknownTypeBIReport from '@/modules/external-bi/views/components/UnknownTypeBIReport.vue'

export default {
  name: 'ExternalBI',
  components: {
    LookerBIReport,
    PowerBIReport,
    UnknownTypeBIReport,
  },
  props: {
    reportRoute: {
      type: String,
      required: true,
    },
  },
  computed: {
    getExternalBIReport() {
      const reports = mainUseStore().getExternalBIReports
      return reports.find((report) => report.route === this.reportRoute)
    },
    componentToUse() {
      const reportsComponents = {
        LOOKER: 'LookerBIReport',
        POWERBI: 'PowerBIReport',
      }
      return reportsComponents[this.getExternalBIReport.type] || 'UnknownTypeBIReport'
    },
  },
}
</script>
